import styled from 'styled-components';
import { secondaryText } from 'styles/theme';

// We are doing a named export here to maintain backwards compatibility with existing code,
// but this could be refactored to a default export at some point.
// To allow overriding the margin specificity here, we need to apply the margin outside
// of the styled component.
export const SecondaryText = styled.p`
    color: ${secondaryText};
    margin: 0;
`;

export const SecondaryTextSpan = styled.span`
    color: ${secondaryText};
    margin: 0;
`;
